export type GameErrorCode =
  | 'INVALID'
  | 'NOT_FOUND'
  | 'CONFLICT'
  | 'NAME_TAKEN'
  | 'ALREADY_HAS_CHARACTER'
  | 'NOT_ENOUGH'
  | 'BLOCKED_BY_STATE'
  | 'WRONG_PLACE'
  | 'RATE_LIMITED'
  | 'UNAUTHORISED'
  | 'FORBIDDEN'
  | 'BANNED'
  | 'MUTED'
  | 'RENAME_REQUIRED';

/** A rule rejection. Carries a player-facing message. */
export class GameError extends Error {
  constructor(
    readonly code: GameErrorCode,
    message: string,
  ) {
    super(message);
    this.name = 'GameError';
  }
}

export function assertGame(cond: unknown, code: GameErrorCode, message: string): asserts cond {
  if (!cond) throw new GameError(code, message);
}
